import { RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class SetLastCountMutation implements RecommendationsMutation {
  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.setLastCount]: (recommendationsState: RecommendationsState, lastCount: number) => {
      recommendationsState.lastCount = lastCount;
    }
  };
}
